import { Container, Card, Row, Col } from "@themesberg/react-bootstrap";
import { Routes } from "../../routes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

import React, { useEffect, useState } from "react";
import queryString from "query-string";
import { useLocation } from "react-router";

import { FormattedMessage } from "react-intl";

const Confirm = ({ logged }) => {
  const [msg, setMsg] = useState("");
  const location = useLocation();
  const query = queryString.parse(location.search);

  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + "/api/finalize", {
      method: "post",
      body: JSON.stringify({ token: query.token }),
    })
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp.msg) {
          setMsg(resp.msg);
        }
      });
  }, [query.token]);

  return (
    <main>
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <Container>
          <p className="text-center">
            <Card.Link
              as={Link}
              to={Routes.Home.path}
              className="text-gray-700"
            >
              <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> <FormattedMessage id="goHome" />
            </Card.Link>
          </p>
          <Row className="justify-content-center form-bg-image">
            <Col
              xs={12}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <div className="text-center text-md-center mb-4 mt-md-0">
                  <h3 className="mb-0"><FormattedMessage id="welcome" /></h3>
                </div>

                <div className="d-flex justify-content-center align-items-center mt-4">
                  <p className="fw-normal">{msg}</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};

export default Confirm;
